import React from 'react';

import IconBtn from '../../icon-btn/icon-btn';
import Badge from '../badge/badge';

import './datepicker-bottom-action-panel.scss';

interface DatepickerBottomActionPanelProps {
  onBadgeClick: (
    type:
      | 'week'
      | 'month'
      | 'quarter-1'
      | 'quarter-2'
      | 'quarter-3'
      | 'quarter-4'
  ) => void;
  onSubmit: () => void;
  onCancel: () => void;
  disabled: boolean;
}

const DatepickerBottomActionPanel: React.FC<DatepickerBottomActionPanelProps> = ({
  onBadgeClick,
  onSubmit,
  onCancel,
  disabled,
}) => (
  <div className="datepicker-bottom-action-panel">
    <div className="badges-list">
      <Badge onClick={() => onBadgeClick('week')}>Неделя</Badge>
      <Badge onClick={() => onBadgeClick('month')}>Месяц</Badge>
      <Badge onClick={() => onBadgeClick('quarter-1')}>1 квартал</Badge>
      <Badge onClick={() => onBadgeClick('quarter-2')}>2 квартал</Badge>
      <Badge onClick={() => onBadgeClick('quarter-3')}>3 квартал</Badge>
      <Badge onClick={() => onBadgeClick('quarter-4')}>4 квартал</Badge>
    </div>
    <IconBtn
      sm
      onClick={onCancel}
      title="Сброс"
      outlined
    />
    <IconBtn sm onClick={onSubmit} title="Выбрать" disabled={disabled} />
  </div>
);

export default DatepickerBottomActionPanel;
